export default __webpack_public_path__ + "static/media/promo.7b4207ca.gif";